import React, { useState } from 'react';
import { Box, Typography, CircularProgress, Backdrop } from '@mui/material';
import WeeklyQuizzesSelector from './WeeklyQuizzesSelector.jsx';
import WeeklyQuizzesQuizSelector from './WeeklyQuizzesQuizSelector.jsx';
import { WeeklyQuizzesProvider, useWeeklyQuizzes } from './WeeklyQuizzesContext.jsx';
import dayjs from 'dayjs';
import { executeFetch } from '../Util.js';
import { config } from '../Const.js';

const WeeklyQuizzesContent = () => {
    const { assignments, loading, saving, setSaving, loadAssignments } = useWeeklyQuizzes();
    const [selectedWeek, setSelectedWeek] = useState(dayjs().startOf('week').add(1, 'day'));
    const [selectedCategory, setSelectedCategory] = useState(null);

    const saveAssignment = (category, quiz) => {
        setSaving(true);
        const date = selectedWeek.format('YYYY-MM-DD');
        
        const url = `${config.SERVER_URL}/api/v1/admin/weekly-quizzes/save?date=${date}&category=${encodeURIComponent(category)}&quizId=${encodeURIComponent(quiz.id)}`;
        
        executeFetch(
            url,
            "post",
            null,
            null,
            null,
            () => {
                loadAssignments();
                setSaving(false);
            },
            (err) => {
                alert("Error saving assignment: " + err);
                setSaving(false);
            }
        );
    };

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ p: 3, height: '100%', position: 'relative' }}>
            {saving && (
                <Backdrop
                    sx={{ 
                        color: '#fff', 
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        backgroundColor: 'rgba(0,0,0,0.1)' 
                    }}
                    open={saving}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            )}
            <Typography variant="h4" sx={{ mb: 3 }}>Weekly Quizzes Selection</Typography>
            <Box sx={{ display: 'flex', gap: 4, height: 'calc(100% - 60px)' }}>
                <Box sx={{ width: '35%' }}>
                    <WeeklyQuizzesSelector 
                        selectedWeek={selectedWeek} 
                        setSelectedWeek={setSelectedWeek} 
                        assignments={assignments}
                        onCategorySelect={setSelectedCategory}
                    />
                </Box>
                <Box sx={{ width: '65%' }}>
                    <WeeklyQuizzesQuizSelector 
                        category={selectedCategory} 
                        assignments={assignments}
                        selectedWeek={selectedWeek}
                        onSelectQuiz={(quiz) => {
                            saveAssignment(selectedCategory, quiz);
                            setSelectedCategory(null);
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

const WeeklyQuizzes = () => {
    return (
        <WeeklyQuizzesProvider>
            <WeeklyQuizzesContent />
        </WeeklyQuizzesProvider>
    );
};

export default WeeklyQuizzes;

